'use strict';

angular.module('ClinicApp').factory('PhotoService', function(PhotoResource) {
  return {
    deletePhoto: function(modelType, modelId, photoName) {
      return PhotoResource['delete']({
        modelType: modelType,
        modelId: modelId,
        photoName: photoName,
      }).$promise;
    },
    orderPhotos: function(modelType, modelId, photoOrder) {
      return PhotoResource.update({
        modelType: modelType,
        modelId: modelId,
        photoName: 'order',
      }, photoOrder).$promise;
    },
  };
});
